import { render, staticRenderFns } from "./refuseInvitation.vue?vue&type=template&id=0a182bad"
import script from "./refuseInvitation.vue?vue&type=script&lang=js"
export * from "./refuseInvitation.vue?vue&type=script&lang=js"
import style0 from "./refuseInvitation.vue?vue&type=style&index=0&id=0a182bad&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports